import { Masthead } from "@lifesg/react-design-system/masthead";
import { MastheadContainer } from "./styles";

const NavbarGrey = (): JSX.Element => (
	<MastheadContainer>
		<Masthead />
	</MastheadContainer>
);
export default NavbarGrey;
